import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	rankingErrorTitle: {
		id: 'business-timeline.controllers.timeline-view-issues.ranking-error-title',
		defaultMessage: "Something's gone wrong",
		description: 'Error message informing the user that ranked an item has failed',
	},
	rankingErrorMessage: {
		id: 'business-timeline.controllers.timeline-view-issues.ranking-error-message',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Error description informing the user that ranked an item has failed',
	},
	loadingItemsErrorTitle: {
		id: 'business-timeline.controllers.timeline-view-issues.loading-items-error-title',
		defaultMessage: "Timeline items couldn't be retrieved",
		description: 'Error message informing the user that loading timeline items failed',
	},
	loadingItemsErrorDescription: {
		id: 'business-timeline.controllers.timeline-view-issues.loading-items-error-description',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Error description informing the user that loading timeline items failed',
	},
});
